import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getCookie } from "components/common/cookie";
const initialState = {
  mainPosts: [], // 전체포스트
  detailPost: [],
  popularPosts: [], // 인기게시물, 최대5개 지정가능
  searchPosts: [],
  accusePosts: [],
  accuseComments: [],
  accuseRecomments: [],
  imagePaths: [],
  categoryArray: [
    "전체",
    "질문답변",
    "디자인",
    "작품자랑",
    "꽃집운영",
    "정보공유",
    "구인구직",
    "중고거래",
    "기타",
  ],

  loadPostLoading: false,
  loadPostDone: false,
  loadPostError: null,
  loadDetailPostLoading: false,
  loadDetailPostDone: false,
  loadDetailPostError: null,
  addPostLoading: false,
  addPostDone: false,
  addPostError: null,
  updatePostLoading: false,
  updatePostDone: false,
  updatePostError: null,
  removePostLoading: false,
  removePostDone: false,
  removePostError: null,
  addCommentLoading: false,
  addCommentDone: false,
  addCommentError: null,
  updateCommentLoading: false,
  updateCommentDone: false,
  updateCommentError: null,
  removeCommentLoading: false,
  removeCommentDone: false,
  removeCommentError: null,
  accuseCommentLoading: false,
  accuseCommentDone: false,
  accuseCommentError: null,
  addRecommentLoading: false,
  addRecommentDone: false,
  addRecommentError: null,
  updateRecommentLoading: false,
  updateRecommentDone: false,
  updateRecommentError: null,
  removeRecommentLoading: false,
  removeRecommentDone: false,
  removeRecommentError: null,
  accuseRecommentLoading: false,
  accuseRecommentDone: false,
  accuseRecommentError: null,
  accusePostLoading: false,
  accusePostDone: false,
  accusePostError: null,
  searchPostLoading: false,
  searchPostDone: false,
  searchPostError: null,
  userInfoLoading: false,
  userInfoDone: false,
  userInfoError: null,
  isLikedLoading: false,
  isLikedDone: false,
  isLikedError: null,
  commentIsLikedLoading: false,
  commentIsLikedDone: false,
  commentIsLikedError: null,
  recommentIsLikedLoading: false,
  recommentIsLikedDone: false,
  recommentIsLikedError: null,
  popularPostLoading: false,
  popularPostDone: false,
  popularPostError: null,
  loadPopularPostLoading: false,
  loadPopularPostDone: false,
  loadPopularPostError: null,
};

const token = {
  Authorization: `Bearer ${getCookie("AccessToken")}`,
};

// formData.append("images", v, { type: "multipart/form-data" }),

const addPost = createAsyncThunk("post/addPost", async (payload) => {
  const formData = new FormData();
  payload.images?.map((v) => formData.append("images", v));
  formData.append("content", payload.content);
  formData.append("category", payload.category);

  const config = {
    headers: {
      Authorization: `Bearer ${getCookie("AccessToken")}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const { data } = await axios.post(
      "https://node.floway.co.kr/boards",
      formData,
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const addComment = createAsyncThunk("post/addComment", async (payload) => {
  const config = {
    headers: token,
  };

  try {
    const { data } = await axios.post(
      `https://node.floway.co.kr/comments/${payload.boardId}`,
      { content: payload.content },
      config,
    );
    console.log("테스트슬라이스", data);
    return data;
  } catch (err) {
    console.log("테스트 실패 슬라이스");
    return err.response.data;
  }
});

const addRecomment = createAsyncThunk("post/addRecomment", async (payload) => {
  const config = {
    headers: token,
  };

  try {
    const { data } = await axios.post(
      `https://node.floway.co.kr/recomments/${payload.commentId}`,
      { content: payload.content },
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const loadPost = createAsyncThunk("post/loadPost", async (payload) => {
  const config = {
    headers: token,
  };
  const { category, page } = payload;

  try {
    const { data } = await axios.get(
      `https://node.floway.co.kr/boards?category=${category}&page=${page}`,
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const loadDetailPost = createAsyncThunk(
  "post/loadDetailPost",
  async (boardId) => {
    const config = {
      headers: token,
    };
    try {
      const { data } = await axios.get(
        `https://node.floway.co.kr/boards/${boardId}`,
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

const updatePost = createAsyncThunk("post/updatePost", async (payload) => {
  const formData = new FormData();
  payload.images?.map((v) => formData.append("images", v));
  formData.append("content", payload.content);
  formData.append("category", payload.category);

  const config = {
    headers: token,
  };

  try {
    const { data } = await axios.put(
      `https://node.floway.co.kr/boards/${payload.boardId}`,
      formData,
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const updateComment = createAsyncThunk(
  "post/updateComment",
  async (payload) => {
    const config = {
      headers: token,
    };

    console.log(payload);
    try {
      const { data } = await axios.put(
        `https://node.floway.co.kr/comments/${payload.commentId}`,
        { content: payload.content },
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

const updateRecomment = createAsyncThunk(
  "post/updateRecomment",
  async (payload) => {
    const config = {
      headers: token,
    };

    try {
      const { data } = await axios.put(
        `https://node.floway.co.kr/recomments/${payload.recommentId}`,
        { content: payload.content },
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

const removePost = createAsyncThunk("post/removePost", async (boardId) => {
  const config = {
    headers: token,
  };

  try {
    const { data } = await axios.delete(
      `https://node.floway.co.kr/boards/${boardId}`,
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const removeComment = createAsyncThunk(
  "post/removeComment",
  async (payload) => {
    const config = {
      headers: token,
    };
    try {
      console.log("페이로드", payload);
      const { data } = await axios.delete(
        `https://node.floway.co.kr/comments/${payload.commentId}`,
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

const removeRecomment = createAsyncThunk(
  "post/removeRecomment",
  async (payload) => {
    const config = {
      headers: token,
    };

    try {
      const { data } = await axios.delete(
        `https://node.floway.co.kr/recomments/${payload.recommentId}`,
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

const accusePost = createAsyncThunk("post/accusePost", async (payload) => {
  const config = {
    headers: token,
  };

  try {
    const { data } = await axios.post(
      `https://node.floway.co.kr/boards/${payload.boardId}/report`,
      { content: payload.content },
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const accuseComment = createAsyncThunk(
  "post/accuseComment",
  async (payload) => {
    const config = {
      headers: token,
    };

    try {
      const { data } = await axios.post(
        `https://node.floway.co.kr/comments/${payload.commentId}/report`,
        { content: payload.content },
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

const accuseRecomment = createAsyncThunk(
  "post/accuseRecomment",
  async (payload) => {
    const config = {
      headers: token,
    };

    try {
      const { data } = await axios.post(
        `https://node.floway.co.kr/recomments/${payload.recommentId}/report`,
        { content: payload.content },
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

const searchPost = createAsyncThunk("post/searchPost", async (payload) => {
  const config = {
    headers: token,
  };
  try {
    const { keyword, page } = payload;
    console.log("리덕스 키워드", keyword);
    const { data } = await axios.get(
      `https://node.floway.co.kr/boards/search?keyword=${keyword}&page=${page}`,
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const getUser = createAsyncThunk("post/getuser", async () => {
  const config = {
    headers: token,
  };

  try {
    const { data } = axios.get("https://node.floway.co.kr/users", config);
    return data;
  } catch (err) {
    return err.response.data;
  }
});

// toggleLiked
const toggleLiked = createAsyncThunk("post/toggleLiked", async (boardId) => {
  const config = {
    headers: token,
  };
  try {
    const { data } = await axios.post(
      `https://node.floway.co.kr/boards/${boardId}/like`,
      {},
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

// toggleLikedComment
const toggleLikedComment = createAsyncThunk(
  "post/toggleLikedComment",
  async (commentId) => {
    const config = {
      headers: token,
    };
    try {
      const { data } = await axios.post(
        `https://node.floway.co.kr/comments/${commentId}/like`,
        {},
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

// toggleLikedRecomment
const toggleLikedRecomment = createAsyncThunk(
  "post/toggleLikedRecomment",
  async (recommentId) => {
    const config = {
      headers: token,
    };
    try {
      const { data } = await axios.post(
        `https://node.floway.co.kr/recomments/${recommentId}/like`,
        {},
        config,
      );
      return data;
    } catch (err) {
      return err.response.data;
    }
  },
);

// popularPost
const popularPost = createAsyncThunk("post/popularPost", async (boardId) => {
  const config = {
    headers: token,
  };
  try {
    const { data } = await axios.patch(
      `https://node.floway.co.kr/boards/${boardId}/best`,
      {},
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

// loadPopularPost
const loadPopularPost = createAsyncThunk("post/loadPopularPost", async () => {
  const config = {
    headers: token,
  };
  try {
    const { data } = await axios.get(
      `https://node.floway.co.kr/boards/best`,
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // addPost
    builder
      .addCase(addPost.pending, (state) => {
        state.addPostLoading = true;
      })
      .addCase(addPost.fulfilled, (state, action) => {
        state.addPostLoading = false;
        state.addPostDone = true;
      })
      .addCase(addPost.rejected, (state) => {
        state.addPostLoading = false;
        state.addPostError = true;
      });

    // addComment
    builder
      .addCase(addComment.pending, (state) => {
        state.addCommentLoading = true;
      })
      .addCase(addComment.fulfilled, (state, action) => {
        state.addCommentLoading = false;
        state.addCommentDone = true;
      })
      .addCase(addComment.rejected, (state) => {
        state.addCommentLoading = false;
        state.addCommentError = true;
      });

    // addRecomment
    builder
      .addCase(addRecomment.pending, (state) => {
        state.addRecommentLoading = true;
      })
      .addCase(addRecomment.fulfilled, (state, action) => {
        state.addRecommentLoading = false;
        state.addRecommentDone = true;
      })
      .addCase(addRecomment.rejected, (state) => {
        state.addRecommentLoading = false;
        state.addRecommentError = true;
      });

    // loadPost
    builder
      .addCase(loadPost.pending, (state) => {
        state.loadPostLoading = true;
      })
      .addCase(loadPost.fulfilled, (state, action) => {
        state.loadPostLoading = false;
        state.loadPostDone = true;
        state.mainPosts = [...state.mainPosts, ...action.payload.data];
      })
      .addCase(loadPost.rejected, (state) => {
        state.loadPostLoading = false;
        state.loadPostError = true;
      });

    // loadDetailPost
    builder
      .addCase(loadDetailPost.pending, (state) => {
        state.loadDetailPostLoading = true;
        state.detailPost = [];
      })
      .addCase(loadDetailPost.fulfilled, (state, action) => {
        state.loadDetailPostLoading = false;
        state.loadDetailPostDone = true;
        state.detailPost = action.payload.data[0];
      })

      .addCase(loadDetailPost.rejected, (state) => {
        state.loadDetailPostLoading = false;
        state.loadDetailPostError = true;
      });

    // updatePost
    builder
      .addCase(updatePost.pending, (state) => {
        state.updatePostLoading = true;
      })
      .addCase(updatePost.fulfilled, (state, action) => {
        state.updatePostLoading = false;
        state.updatePostDone = true;
      })
      .addCase(updatePost.rejected, (state) => {
        state.updatePostLoading = false;
        state.updatePostError = true;
      });

    // updateComment
    builder
      .addCase(updateComment.pending, (state) => {
        state.updateCommentLoading = true;
      })
      .addCase(updateComment.fulfilled, (state, action) => {
        state.updateCommentLoading = false;
        state.updateCommentDone = true;
      })
      .addCase(updateComment.rejected, (state) => {
        state.updateCommentLoading = false;
        state.updateCommentError = true;
      });

    // updateRecomment
    builder
      .addCase(updateRecomment.pending, (state) => {
        state.updateRecommentLoading = true;
      })
      .addCase(updateRecomment.fulfilled, (state, action) => {
        state.updateRecommentLoading = false;
        state.updateRecommentDone = true;
      })
      .addCase(updateRecomment.rejected, (state) => {
        state.updateRecommentLoading = false;
        state.updateRecommentError = true;
      });

    // removePost
    builder
      .addCase(removePost.pending, (state) => {
        state.removePostLoading = true;
      })
      .addCase(removePost.fulfilled, (state, action) => {
        state.removePostLoading = false;
        state.removePostDone = true;

        const currentPostIndex = state.mainPosts.findIndex(
          (post) => post.boardId === action.payload.boardId,
        );
        state.mainPosts.splice(currentPostIndex, 1);
      })
      .addCase(removePost.rejected, (state) => {
        state.removePostLoading = false;
        state.removePostError = true;
      });

    // removeComment
    builder
      .addCase(removeComment.pending, (state) => {
        state.removeCommentLoading = true;
      })
      .addCase(removeComment.fulfilled, (state, action) => {
        state.removeCommentLoading = false;
        state.removeCommentDone = true;

        console.log("리덕스에러!!", action.payload);
        // const currentPostIndex = state.mainPosts.findIndex(
        //   (post) => post.boardId === action.payload.data[0]?.boardId,
        // );
        // state.mainPosts[currentPostIndex] = action.payload.data[0];
      })
      .addCase(removeComment.rejected, (state) => {
        state.removeCommentLoading = false;
        state.removeCommentError = true;
      });

    // removeRecomment
    // remove성공시 아래 코드 지워도 되는지 테스트
    builder
      .addCase(removeRecomment.pending, (state) => {
        state.removeRecommentLoading = true;
      })
      .addCase(removeRecomment.fulfilled, (state, action) => {
        state.removeRecommentLoading = false;
        state.removeRecommentDone = true;

        // 아래코드 대댓글찾는걸로 변경할것
        // const currentPostIndex = state.mainPosts.findIndex(
        //   (post) => post.boardId === action.payload.data[0].boardId,
        // );
        // state.mainPosts[currentPostIndex] = action.payload.data[0];
      })
      .addCase(removeRecomment.rejected, (state) => {
        state.removeRecommentLoading = false;
        state.removeRecommentError = true;
      });

    // accusePost
    builder
      .addCase(accusePost.pending, (state) => {
        state.accusePostLoading = true;
      })
      .addCase(accusePost.fulfilled, (state, action) => {
        state.accusePostLoading = false;
        state.accusePostDone = true;

        state.accusePosts.unshift(action.payload.boardId);
      })
      .addCase(accusePost.rejected, (state) => {
        state.accusePostLoading = false;
        state.accusePostError = true;
      });

    // accuseComment
    builder
      .addCase(accuseComment.pending, (state) => {
        state.accuseCommentLoading = true;
      })
      .addCase(accuseComment.fulfilled, (state, action) => {
        state.accuseCommentLoading = false;
        state.accuseCommentDone = true;

        const { boardId, commentId } = action.payload;
        const payload = {
          boardId: boardId,
          commentId: parseInt(commentId),
        };
        state.accuseComments.unshift(payload);
      })
      .addCase(accuseComment.rejected, (state) => {
        state.accuseCommentLoading = false;
        state.accuseCommentError = true;
      });

    // accuseRecomment
    builder
      .addCase(accuseRecomment.pending, (state) => {
        state.accuseRecommentLoading = true;
      })
      .addCase(accuseRecomment.fulfilled, (state, action) => {
        state.accuseRecommentLoading = false;
        state.accuseRecommentDone = true;

        const { boardId, commentId, recommentId } = action.payload;
        const payload = {
          boardId: boardId,
          commentId: commentId,
          recommentId: parseInt(recommentId),
        };
        state.accuseRecomments.unshift(payload);
      })
      .addCase(accuseRecomment.rejected, (state) => {
        state.accuseRecommentLoading = false;
        state.accuseRecommentError = true;
      });

    // searchPost
    builder
      .addCase(searchPost.pending, (state) => {
        state.searchPostLoading = true;
      })
      .addCase(searchPost.fulfilled, (state, action) => {
        state.searchPostLoading = false;
        state.searchPostDone = true;
        state.searchPosts = action.payload.data;
      })
      .addCase(searchPost.rejected, (state) => {
        state.searchPostLoading = false;
        state.searchPostError = true;
      });

    // getUser
    builder
      .addCase(getUser.pending, (state) => {
        state.userInfoLoading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.userInfoLoading = false;
        state.userInfoDone = true;
        state.me = action.payload;
      })
      .addCase(getUser.rejected, (state) => {
        state.userInfoLoading = false;
        state.userInfoError = true;
      });

    // toggleLiked
    builder
      .addCase(toggleLiked.pending, (state) => {
        state.isLikedLoading = true;
      })
      .addCase(toggleLiked.fulfilled, (state, action) => {
        state.isLikedLoading = false;
        state.isLikedDone = true;
      })
      .addCase(toggleLiked.rejected, (state) => {
        state.isLikedLoading = false;
        state.isLikedError = true;
      });

    // toggleLikedComment
    builder
      .addCase(toggleLikedComment.pending, (state) => {
        state.commentIsLikedLoading = true;
      })
      .addCase(toggleLikedComment.fulfilled, (state, action) => {
        state.commentIsLikedLoading = false;
        state.commentIsLikedDone = true;
      })
      .addCase(toggleLikedComment.rejected, (state) => {
        state.commentIsLikedLoading = false;
        state.commentIsLikedError = true;
      });

    // toggleLikedRecomment
    builder
      .addCase(toggleLikedRecomment.pending, (state) => {
        state.recommentIsLikedLoading = true;
      })
      .addCase(toggleLikedRecomment.fulfilled, (state, action) => {
        state.recommentIsLikedLoading = false;
        state.recommentIsLikedDone = true;
      })
      .addCase(toggleLikedRecomment.rejected, (state) => {
        state.recommentIsLikedLoading = false;
        state.recommentIsLikedError = true;
      });

    // popularPost
    builder
      .addCase(popularPost.pending, (state) => {
        state.popularPostLoading = true;
      })
      .addCase(popularPost.fulfilled, (state, action) => {
        state.popularPostLoading = false;
        state.popularPostDone = true;
      })
      .addCase(popularPost.rejected, (state) => {
        state.popularPostLoading = false;
        state.popularPostError = true;
      });

    // loadPopularPost
    builder
      .addCase(loadPopularPost.pending, (state) => {
        state.loadPopularPostLoading = true;
      })
      .addCase(loadPopularPost.fulfilled, (state, action) => {
        state.loadPopularPostLoading = false;
        state.loadPopularPostDone = true;
        state.popularPosts = action.payload.data;
      })
      .addCase(loadPopularPost.rejected, (state) => {
        state.loadPopularPostLoading = false;
        state.loadPopularPostError = true;
      });
  },
});

export {
  getUser,
  addPost,
  loadPost,
  loadDetailPost,
  updatePost,
  removePost,
  accusePost,
  searchPost,
  addComment,
  updateComment,
  removeComment,
  accuseComment,
  addRecomment,
  updateRecomment,
  removeRecomment,
  accuseRecomment,
  toggleLiked,
  toggleLikedComment,
  toggleLikedRecomment,
  popularPost,
  loadPopularPost,
};
export default postSlice.reducer;
